export class Constants {
    public static readonly URL_ASSET_PORTAL_BROWSER: string = "/_layouts/15/AssetPortalBrowser.aspx";
    public static readonly GUID_EN_TERMSET: string = "ba76b64a-6040-46b7-802c-b606457bac26";
    public static readonly GUID_ES_TERMSET: string = "ea0fb062-9acc-4b4a-bd00-97c4d88ed1d9";
}